import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import "../fitness.scss";
import { fetchWorkoutPlans } from "../../../store/actions";
import WorkoutPlanHeader from "./workoutPlanListHeader";
import NoItemsFoundAlert from "../../../sharedComponents/noItemFoundAlert";
import Loading from "../../../sharedComponents/preloader";

const WorkoutPlans = ({ fetchWorkoutPlans, workoutPlanList, history }) => {
	useEffect(() => {
		fetchWorkoutPlans();
	}, [fetchWorkoutPlans]);

	const [empty, setEmpty] = useState(false);
	useEffect(() => {
		const filter = workoutPlanList && workoutPlanList.filter(item => item.data && item.data.length > 0);
		workoutPlanList && setEmpty(filter.length === 0);
	}, [workoutPlanList])

	const sortBy = (sort) => {
		fetchWorkoutPlans(`order=${sort}`);
	};

	const goToPage = (id) => {
		history.push(`/fitness/workout-plans/${id}/details`);
	};

	return (
		<section className="page page-fitness-workout-plans">
			<div className="container mt-6">
				<WorkoutPlanHeader workoutPlans={workoutPlanList} empty={empty} sortBy={sortBy} />
				{workoutPlanList
					? workoutPlanList.map((item, index) => (
						<div key={index}>
							{item.data && item.data.length > 0 ? (
								<React.Fragment>
									<h4 className="text-primary-dark mt-3 mb-4 border-bottom-light pb-2">{item.subgroup}</h4>
									<div className="row">
										{item.data.map((card) => (
											<div key={card.id} className="col-3 mb-3 pb-2">
												<div
													className="card card-default flex-row h-100 rounded border-0 p-3 pointer align-items-start"
													onClick={() => goToPage(card.id)}>
													<div className="workout-plan-icon">
														<i className="icon icon-workout-plan xl-icon text-primary-dark" />
													</div>
													<div className="pl-3">
														<h4 className="font-weight-bold">{card.name} </h4>
														<p className="text-primary mb-0">
															{card.group}{" "}
															<span className="text-primary-dark">{item.subgroup} </span>
														</p>
														<p className="mb-0">{card.description}</p>
													</div>
												</div>
											</div>
										))}
									</div>
								</React.Fragment>
							) : null}
						</div>
					))
					: null}
				{workoutPlanList && empty ? <NoItemsFoundAlert message="Np plans found!" /> : null}
				{!workoutPlanList ? <Loading /> : null}
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { WorkoutPlans } = state;
	return {
		workoutPlanList: get(WorkoutPlans, "workoutPlanList.results", null)
	};
};

const mapDispatchToProps = {
	fetchWorkoutPlans
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WorkoutPlans);
